import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';
import { TranslateFn } from '../hooks/useSessionFormI18n';

export interface SubmitFooterProps {
    submitting: boolean;
    autoSaving: boolean;
    dirty: boolean;
    onReset: () => void;
    onSubmit: () => void;
    t: TranslateFn;
}

export const SubmitFooter: React.FC<SubmitFooterProps> = ({
    submitting,
    autoSaving,
    dirty,
    onReset,
    onSubmit,
    t,
}) => {
    const theme = useTheme();
    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                flexWrap: 'wrap',
                gap: 2,
                bgcolor: alpha(theme.palette.primary.main, 0.08),
                borderRadius: 3,
                px: { xs: 2, md: 3 },
                py: { xs: 2, md: 3 },
            }}
        >
            <Box>
                <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                    {t('footer_changes_later_title')}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    {t('footer_changes_later_body')}
                </Typography>
            </Box>
            <Box sx={{ display: 'flex', gap: 1.5, flexWrap: 'wrap' }}>
                <Button
                    variant="outlined"
                    color="primary"
                    onClick={onReset}
                    disabled={submitting || autoSaving || !dirty}
                >
                    {t('btn_reset')}
                </Button>
                <Button
                    variant="contained"
                    size="large"
                    color="primary"
                    onClick={onSubmit}
                    disabled={submitting || autoSaving || !dirty}
                >
                    {submitting ? t('btn_saving') : t('btn_submit')}
                </Button>
            </Box>
        </Box>
    );
};
